(function () {
  'use strict';

  let angular = window.angular;

  DetectionsHeatmapRouter.$inject = ['$stateProvider'];

  angular.module('app').config(DetectionsHeatmapRouter);

  function DetectionsHeatmapRouter($stateProvider) {
    $stateProvider.state('member.project.detectionsHeatmap', {
      url: '/detections-heatmap/:assetId',
      component: 'detectionsHeatmapComponent',
      authenticated: true,
      params: {
        assetId: {
          type: 'string',
          dynamic: true,
          squash: true,
        },
      },
      ncyBreadcrumb: {
        label: 'Detections Heatmap',
      },
      resolve: {
        dependencies: [
          '$ocLazyLoad',
          '$rootScope',
          function ($ocLazyLoad, $root) {
            const style = $root.darkMode ? 'dark' : 'light';
            return $ocLazyLoad.load([
              window.assetsPath + `/css/detections-heatmap.style-${style}.css`,
              window.assetsPath + '/js/app/detections-heatmap.module.min.js',
            ]);
          },
        ],
        param: [
          () => {
            return Promise.resolve('...');
          },
        ],
      },
    });
  }
})();
